<template>
  <v-container fill-height 
  :style="{
  minHeight: $vuetify.breakpoint.xsOnly ? 'calc(100vh - 300px)' : 
  $vuetify.breakpoint.smOnly ? 'calc(100vh - 300px)' :
  'calc(100vh - 150px)'
}">
    <!-- margin-bottom: 280px !important; -->
      <v-card width="450"  max-width="450" class="mx-auto mb-6 pa-2" :elevation="2" 
      v-bind:style="{ minWidth: 'auto', color: '#215295' }"
      style="border-radius:30px;
      box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
        <v-card-title class="justify-center mt-6"><h1>{{
          this.lg_login.title
        }}</h1></v-card-title>
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <v-form @submit.prevent="submit" v-model="valid" ref="form" :class="{'px-6': !$vuetify.breakpoint.xsOnly}" >
            <!-- Username field -->
              <v-row class="mt-4" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                <!--  prepend-inner-icon="mdi-email-outline" -->
            <v-text-field
              dense
              outlined
              :label="this.lg_login.email"
              :placeholder="this.lg_login.email_place"
              v-model="account.username"
              required
              :rules="emailRules"
              hide-details
            ></v-text-field>
            </v-col>
                </v-row>
          <v-row class="" justify="center" >
            <!-- Password field -->
              <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                <!--  prepend-inner-icon="mdi-lock-outline" -->
            <v-text-field
              outlined
              :label="this.lg_login.password"
              :placeholder="this.lg_login.password_place"
              v-model="account.password"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              @click:append="e1 = !e1"
              :type="e1 ? 'password' : 'text'"
              required
              :rules="passwordRules"
              dense
              hide-details
            ></v-text-field>
            </v-col>
            </v-row>

              <v-row class="" justify="center" >
                 <v-col align="left" justify="left"  cols="6" xl="6" lg="6" md="6" sm="6" xs="6">
                  <v-checkbox
                  dense
      v-model="checkrememberme"
    >
  <template v-slot:label>
      <span  
      :class="{
  'fontsize-remember-forgotpassword':$vuetify.breakpoint.xsOnly,
   }">
       {{ lg_login.remember_me }}
      </span>
      </template>
  </v-checkbox>
            </v-col>
                 <v-col align="right" justify="right"  cols="6" xl="6" lg="6" md="6" sm="6" xs="6">
            <p
            style="font-size: 16px;"
              class="linkunderline mt-3"
             :class="{
                    'fontsize-remember-forgotpassword':$vuetify.breakpoint.xsOnly,
                  }"
              @click.prevent="$router.push('/forgot-password')"
            >
              {{ this.lg_login.btn_forgot }}
            </p>
            </v-col>
                </v-row>
            <v-alert
              v-model="$store.getters['altlogin']"
              dense
              outlined
              type="error"
            >
              {{ messageAlert }}
            </v-alert>

            <!-- <v-divider></v-divider> -->
            <!-- Buttons   justify-space-between -->
            <!-- <v-layout>
              <v-btn
                :small="buttonsmall"
                color="#205295"
                outlined
                text
                @click.prevent="$router.push('/register-account')"
                >{{ this.lg_login.btn_register }}</v-btn
              >

              <div>
                <v-btn
                  :small="buttonsmall"
                  class="ml-5"
                  v-bind:style="{ marginLeft: '2rem', backgroundColor: '#205295', color: '#ffffff' }"
                  type="submit"
                  :class="{
                    'white--text': valid,
                    disabled: !valid,
                  }"
                  >{{ this.lg_login.btn_login }}</v-btn
                >
              </div>
            </v-layout> -->
        <!-- <input type="submit" :value="this.lg_footer_userrequest.submit" /> -->

           <v-row class="mt-4" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <v-btn
                type="submit"
                class="mb-1 white--text slide-btn"
                width="300"
                height="40"
                v-bind:style="{ minWidth: 'auto', backgroundColor: '#215295' }"
                outlined
              >
              {{ this.lg_login.btn_login }}
              </v-btn>
              </v-col>
              </v-row>
              <v-row class="" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <v-btn
                type="submit"
                class="mb-1 black--text "
                width="300"
                height="40"
                @click.prevent="$router.push('/register-account')"
                v-bind:style="{ minWidth: 'auto',borderColor:'white' }"
                outlined
              >
              {{ this.lg_login.btn_register }}
              </v-btn>
              </v-col>
              </v-row>

          </v-form>
        </v-card-text>
      </v-card>
    <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script lang="js">

import api from "@/services/api";
import LoadingDialog from "@/components/cards/LoadingDialog";
import { server } from "../services/constants";
import { feature } from "../services/constants";
import { lg_login } from "./language/lg_login.js";

  export default  {
    name: 'login',
    props: [],
    created() {
    },
    components: {
      LoadingDialog,
    },
   async beforeCreate() {
      this.$store.state.page_reload = false;
      this.$store.state.altLogin = false;

      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_login = lg_login.login_th
        : this.lg_login = lg_login.login_en;


        // console.log("lg_login: " + JSON.stringify(this.lg_login));
    },
    mounted () {
      localStorage.setItem(server.MEET_STA, "false");
      if (api.isLoggedIn()){
        this.$router.push("/")
      }
      this.$store.state.loadMenu = false;
      this.$store.state.meetSta = false;
      this.$store.state.navMenu = false;
      this.$store.state.loadFooter = true;
    },
    data () {
          return {
            checkrememberme:false,
            messageAlert: this.lg_login.messageAlert,
            account:{
              username:"",
              password:""
            },
            valid: false,
            e1: true,
            password: '',
            passwordRules: [
              (v) => !!v || 'Please enter your password',
            ],
            email: '',
            emailRules: [
              (v) => !!v || 'Please enter your email address',
            ],
          }
        },
        methods: {
          async submit () {
            if (this.$refs.form.validate()) {
              this.$store.state.loadMenu=true;
              this.$store.dispatch({
                                    type: 'doLogin',
                                    username: this.account.username,
                                    password: this.account.password,
                                    rememberme: this.checkrememberme,
                                  }).then((data) => {
                                            //  alert(data)
                                            //  this.$swal.close();
                                            this.$store.state.loadMenu = false;
                                            if(data==false){
                                              // alert("data==false")
                                              this.$router.push("/login-account").catch(()=>{});
                                            }
                                            // else{
                                            //   alert("data==else")
                                            // }
                                  });

            } 
          },
          clear () {
            this.$refs.form.reset()
          }
        },
    computed: {
       buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
       widthcard() {
      switch (this.$vuetify.breakpoint.name) {
       case "xs":
          return "width:90%";
        case "sm":
            return "width:65%";
        case "md":
           return "width:45%";
        case "lg":
           return "width:35%";
        case "xl":
            return "width:25%";
      }
    },
    },


    }
</script>

<style scoped lang="scss">
.buttons {
  display: flex;
  justify-content: flex-end;
}
.v-progress-circular {
  margin: 1rem;
}
.row {
  // padding-top: 40px;
  // padding-bottom: 40px;
  // align-items: center;
  // justify-content: center;
}
.layout {
  margin-top: 20px;
  justify-content: center;
}
.fill-height {
  height: 100%;
}
// .v-text-field.v-text-field--enclosed {
//   margin-right: 20px;
//   margin-left: 20px;
// }
.linkunderline {
  margin-left: 30px;
  margin-top: -10px;
  margin-bottom: 10px;
}
.linkunderline:hover {
  text-decoration: underline;
  cursor: pointer;
}

@media (min-width: 960px) {
  .login-container {
    margin-top: 2rem
  }
}
.fontsize-remember-forgotpassword{
  font-size:12px !important;
}
</style>
